import { render } from "./administrator_list.vue?vue&type=template&id=8fed565a&scoped=true"
import script from "./administrator_list.vue?vue&type=script&lang=js"
export * from "./administrator_list.vue?vue&type=script&lang=js"

import "./administrator_list.vue?vue&type=style&index=0&id=8fed565a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fed565a"]])

export default __exports__